import requestRefreshTrading from 'config/requestRefreshTrading';

export const refreshApiInstance = requestRefreshTrading();
